import VueI18n from './../i18n/i18n';
import AppConstants from '../appConstants';

class TranslateFieldHelper {
    translateBooleanToLocale(value) {
        return value ? VueI18n.t('BOOLEAN').Yes : VueI18n.t('BOOLEAN').No;
    }

    translateNewsStatusById(statusCode) {
        let status = '';
        switch (statusCode) {
            case AppConstants.NEWS_STATUS.SENDNOW:
                status = VueI18n.t('NEWS_STATUS').SENDNOW;
                break;
            case AppConstants.NEWS_STATUS.SAVED:
                status = VueI18n.t('NEWS_STATUS').SAVED;
                break;
            case AppConstants.NEWS_STATUS.SCHEDULED:
                status = VueI18n.t('NEWS_STATUS').SCHEDULED;
                break;
            case AppConstants.NEWS_STATUS.SENT:
                status = VueI18n.t('NEWS_STATUS').SENT;
                break;
            case AppConstants.NEWS_STATUS.ERROR:
                status = VueI18n.t('NEWS_STATUS').ERROR;
                break;
        }
        return status;
    }

    getTranslateField(fieldname, data) {
      if (data) {
        const field = data[`${fieldname}${VueI18n.locale}`];
        if (field) {
          return field;
        }
      }
      return '';
    }

    getSubjectName(subjects, currentCommodity) {
      if (!subjects || subjects.length == 0) {
        return currentCommodity ? currentCommodity.name : '';
      }
        if (currentCommodity.id) {
            const sub = subjects.find(
              item => item.code == currentCommodity.id
            );
            if (sub) {
              // return sub.name;
              let name = sub[`label${VueI18n.locale}`];
              if (name) {
                return name;
              } 
              return sub[`name${VueI18n.locale}`];
            }
          }
          let name = subjects[0][`label${VueI18n.locale}`];
          if (name) {
            return name;
          }
          return subjects[0][`name${VueI18n.locale}`];
    }
    getSubjectData(subjects, currentCommodity) {
        if (currentCommodity.id) {
            const sub = subjects.find(
              item => item.code == currentCommodity.id
            );
            if (sub) {
              return sub;
            }
          }
          return subjects[0];
    }
    getFilterDateList() {
      return [ 
      { id: AppConstants.FILTER_DATE_OPTION.One_Day, name: VueI18n.t('REPORT_FILTER').One_Day },
      { id: AppConstants.FILTER_DATE_OPTION.One_Week, name: VueI18n.t('REPORT_FILTER').One_Week },
      { id: AppConstants.FILTER_DATE_OPTION.One_Month, name: VueI18n.t('REPORT_FILTER').One_Month },
      { id: AppConstants.FILTER_DATE_OPTION.Three_Month, name: VueI18n.t('REPORT_FILTER').Three_Months },
      { id: AppConstants.FILTER_DATE_OPTION.Others, name: VueI18n.t('REPORT_FILTER').Select_Date }
      ]
    }
    getAuthorName(author) {
      if (!author.nickname) return author.name;
      if (VueI18n.locale == 'ZhCn') return author.nicknameZhCn || author.nickname;
      return author.nickname;
    }

}



export default new TranslateFieldHelper();